/**
 * ProtectedRoute — redirects unauthenticated users to /login.
 * Wraps route groups that require any logged-in user.
 * Uses <Outlet /> pattern so it works as a layout route wrapper.
 */
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@/stores/auth-context'

export default function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="h-6 w-6 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to={`/login?returnUrl=${encodeURIComponent(location.pathname)}`} replace />
  }

  return <Outlet />
}
